/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TransferPlayerWithPlayerAndTeams = {
    properties: {
        team_to_id: {
            type: 'number',
            isRequired: true,
        },
        team_from_id: {
            type: 'number',
            isRequired: true,
        },
        player_id: {
            type: 'number',
            isRequired: true,
        },
        position: {
            type: 'PlayerPositionEnum',
            isRequired: true,
        },
        player: {
            type: 'any-of',
            contains: [{
                type: 'PlayerMedium',
            }, {
                type: 'null',
            }],
        },
        team_to: {
            type: 'any-of',
            contains: [{
                type: 'TeamSmall',
            }, {
                type: 'null',
            }],
        },
        team_from: {
            type: 'any-of',
            contains: [{
                type: 'TeamSmall',
            }, {
                type: 'null',
            }],
        },
    },
} as const;
